import { createFileRoute } from "@tanstack/react-router";
import { ComplianceScreen } from "./-compliance/ComplianceScreen";

export const Route = createFileRoute("/$workspace/$project/compliance")({
  staticData: { title: "Compliance" },
  component: ComplianceScreen,
});
